import { Howl } from "howler";

export const depositSuccessSound = new Howl({
  src: ["/sound-effects/apple-pay-sound.mp3"],
});

export const errorSound = new Howl({
  src: ["/sound-effects/error-sound.mp3"],
});

export const turnstileOpenSound = new Howl({
  src: ["/sound-effects/universfield-new-notification-07-210334.mp3"],
});
